<script lang="ts">
import type { FieldValidationType, FormErrors } from '@/modules/form'
import { t } from '@/modules/translations'

type Props = {
	name: string
	errors: FormErrors
}

let { name, errors }: Props = $props()

const errorMessageMap: Record<FieldValidationType, string> = {
	email: 'validations.isEmail',
	phone: 'validations.phone',
	required: 'validations.required',
	checked: 'validations.checkedTerms',
}

let error = $derived(errors[name])

let errorMessage: string | null = $derived(error ? errorMessageMap[error] : null)
</script>

{#if errorMessage}
	<div role="alert" class="text-xs color-red-500">{$t(errorMessage)}</div>
{/if}
